import { get, getFile, ShowToastType } from './fetchUtils';

export type FilterParams = {
  selectedSessionNames: string[];
  selectedCountries: string[];
  selectedStates: string[];
  selectedDistricts: string[];
  selectedBlocks: string[];
  selectedClusters: string[];
  selectedSchoolGroups: string[];
  selectedSchoolIds: string[];
  selectedGrades: string[];
  startDate: number;
  endDate: number;
  dataSource: string;
};
export type FilterParamsForExel = {
  selectedSessionNames: string[];
  selectedCountries: string[];
  selectedStates: string[];
  selectedDistricts: string[];
  selectedBlocks: string[];
  selectedClusters: string[];
  selectedSchoolGroups: string[];
  selectedSchoolIds: string[];
  selectedGrades: string[];
  lowerLimit: number;
  upperLimit: number;
  startDate: number;
  endDate: number;
  dataSource: string;
};
export type CompareSurveyReportExelBody = {
  selectedSessionNames: string[];
  selectedCountries: string[];
  selectedStates: string[];
  selectedDistricts: string[];
  selectedBlocks: string[];
  selectedClusters: string[];
  selectedSchoolGroups: string[];
  selectedSchoolIds: string[];
  selectedGrades: string[];
  lowerLimit: number;
  upperLimit: number;
  startDate: number;
  endDate: number;
  dataSource: string;
  grade: string;
  subject: string;
  firstSurveyId: string;
  secondSurveyId: string;
};
export type CompareStaticticsReportExelBody = {
  selectedSessionNames: string[];
  selectedCountries: string[];
  selectedStates: string[];
  selectedDistricts: string[];
  selectedBlocks: string[];
  selectedClusters: string[];
  selectedSchoolGroups: string[];
  selectedSchoolIds: string[];
  selectedGrades: string[];
  lowerLimit: number;
  upperLimit: number;
  startDate: number;
  endDate: number;
  dataSource: string;
  grade: string;
  subject: string;
  baselineSurveyId: string[];
  progressSurveyId: string[];
};
export type ProgressStaticticsBody = {
  selectedSessionNames: string[];
  selectedCountries: string[];
  selectedStates: string[];
  selectedDistricts: string[];
  selectedBlocks: string[];
  selectedClusters: string[];
  selectedSchoolGroups: string[];
  selectedSchoolIds: string[];
  selectedGrades: string[];
  startDate: number;
  endDate: number;
  dataSource: string;
  grade: string;
  subject: string;
  baselineSurveyId: string[];
  progressSurveyId: string[];
};
export type SchoolProgressBody = {
  selectedSessionNames: string[];
  selectedCountries: string[];
  selectedStates: string[];
  selectedDistricts: string[];
  selectedBlocks: string[];
  selectedClusters: string[];
  selectedSchoolGroups: string[];
  selectedSchoolIds: string[];
  selectedGrades: string[];
  startDate: number;
  endDate: number;
  dataSource: string;
  grade: string;
  subject: string;
  baselineSurveyId: string[];
  progressSurveyId: string[];
  controllSchoolId: string[];
  treatmentSchoolId: string[];
};
export type FilterParamsWithSubjectAndGrade = {
  selectedSessionNames: string[];
  selectedCountries: string[];
  selectedStates: string[];
  selectedDistricts: string[];
  selectedBlocks: string[];
  selectedClusters: string[];
  selectedSchoolGroups: string[];
  selectedSchoolIds: string[];
  selectedGrades: string[];
  startDate: number;
  endDate: number;
  dataSource: string;
  grade: string;
  subject: string;
};
export const getFetchParticipation = (
  filterParams: FilterParams,
  showToast: ShowToastType
) => {
  return get(
    `api/dashboard/participation/overall-data`,
    filterParams,
    showToast
  );
};
export const getFetchComparativePerformance = (
  filterParams: FilterParams,
  showToast: ShowToastType
) => {
  return get(`api/dashboard/compare/overall-data`, filterParams, showToast);
};
export const getFetchEntityWiseReport = (
  filterParams: FilterParamsWithSubjectAndGrade,
  showToast: ShowToastType
) => {
  return get(`api/dashboard/performance/overall-data`, filterParams, showToast);
};
export const getFetchEntityWisePaperTypePerformance = (
  filterParams: FilterParamsWithSubjectAndGrade,
  showToast: ShowToastType
) => {
  return get(
    `api/dashboard/performance/overall-data-paper-type`,
    filterParams,
    showToast
  );
};
export const getFetchSubmoduleReport = (
  filterParams: FilterParamsWithSubjectAndGrade,
  showToast: ShowToastType
) => {
  return get(`api/dashboard/submodules/overall-data`, filterParams, showToast);
};
export const getFetchPaperCodeReport = (
  filterParams: FilterParamsWithSubjectAndGrade,
  showToast: ShowToastType
) => {
  return get(`api/dashboard/paperCode/overall-data`, filterParams, showToast);
};
export const getCompareReportExel = (
  body: FilterParamsForExel,
  showToast: ShowToastType
) => {
  return getFile(
    `api/dashboard/excel/compareReports/overall-data`,
    body,
    showToast
  );
};
export const getCompareSurveyReportExel = (
  body: CompareSurveyReportExelBody,
  showToast: ShowToastType
) => {
  return getFile(
    `api/dashboard/excel/compareSurveyReports/overall-data`,
    body,
    showToast
  );
};

export const getCompareStaticticsReportExel = (
  body: CompareStaticticsReportExelBody,
  showToast: ShowToastType
) => {
  return getFile(
    `api/dashboard/excel/compareStatisticsReports/overall-data`,
    body,
    showToast
  );
};
export const getFetchDistictGrades = (
  filterParams: FilterParams,
  showToast: ShowToastType
) => {
  return get(
    `api/dashboard/distinct-grade-subject-surveyId`,
    filterParams,
    showToast
  );
};
export const getFetchBaseLineSurveyIds = (
  filterParams: FilterParamsWithSubjectAndGrade,
  showToast: ShowToastType
) => {
  return get(
    `api/dashboard/distinct-baseline-surveyIds`,
    filterParams,
    showToast
  );
};
export const getFetchProgressSurveyIds = (
  filterParams: FilterParamsWithSubjectAndGrade,
  showToast: ShowToastType
) => {
  return get(
    `api/dashboard/distinct-progress-surveyIds`,
    filterParams,
    showToast
  );
};
export const getFetchSlidesProgressData = (
  filterParams: SchoolProgressBody,
  showToast: ShowToastType
) => {
  return get(`api/dashboard/slides/progress-data`, filterParams, showToast);
};
export const getFetchDistinctSchoolIds = (
  filterParams: FilterParamsWithSubjectAndGrade,
  showToast: ShowToastType
) => {
  return get(`api/dashboard/distinct-schools`, filterParams, showToast);
};
export const getFetchSchoolProgressData = (
  filterParams: SchoolProgressBody,
  showToast: ShowToastType
) => {
  return get(
    `api/dashboard/slides/school-progress-data`,
    filterParams,
    showToast
  );
};
export const getFetchSchoolProgressStatictcs = (
  filterParams: ProgressStaticticsBody,
  showToast: ShowToastType
) => {
  return get(`api/dashboard/school-statistics_data`, filterParams, showToast);
};
export const getFetchSlidesBaseLineSurveyIds = (
  filterParams: FilterParamsWithSubjectAndGrade,
  showToast: ShowToastType
) => {
  return get(
    `api/dashboard/slide-data/distinct-baseline-surveyIds`,
    filterParams,
    showToast
  );
};
export const getFetchSlidesProgressSurveyIds = (
  filterParams: FilterParamsWithSubjectAndGrade,
  showToast: ShowToastType
) => {
  return get(
    `api/dashboard/slide-data/distinct-progress-surveyIds`,
    filterParams,
    showToast
  );
};
export const getFetchSlidesControllSchoolIds = (
  filterParams: ProgressStaticticsBody,
  showToast: ShowToastType
) => {
  return get(
    `api/dashboard/slide-data/distinct-control-schoolIds`,
    filterParams,
    showToast
  );
};
export const getFetchSlidesTreatmentSchoolIds = (
  filterParams: ProgressStaticticsBody,
  showToast: ShowToastType
) => {
  return get(
    `api/dashboard/slide-data/distinct-treatment-schoolIds`,
    filterParams,
    showToast
  );
};
